module.exports = __webpack_public_path__ + "static/media/splash.63d56b17.63d56b17.png";